import { t as translate } from '../../../core';

const root = 'taxOperation';

export const title = (key: string) => translate(`${root}.title.${key}`);

export const label = (key: string) => translate(`${root}.label.${key}`);

export const headers = (key: string) => translate(`${root}.header.${key}`);
export const messages = (key: string) => translate(`${root}.messages.${key}`);
